import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TransalateService {

  constructor(){}

  translateUserRole(role: string){
    switch (role) {
      case 'administrator':
        return 'Administrador/a'
      case 'worker':
        return 'Operario/a'
      default:
        return 'Rol Desconocido'
    }
  }
}
